// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"b2dfe6a2","92":"d5b9282b","453":"cb845ceb","556":"d9aee176","621":"9de8c2b8"}[chunkId] + ".chunk.js";
};